var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveLevel3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.612,
    height: 42.205,
    viewBox: "0 0 23.612 42.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2643",
    "data-name": "Group 2643",
    transform: "translate(-574.76 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M23.612,34.406V7.8a2.329,2.329,0,0,0-1.164-2.017L12.97.313a2.328,2.328,0,0,0-2.328,0L1.164,5.785A2.329,2.329,0,0,0,0,7.8v26.6a2.328,2.328,0,0,0,1.164,2.017l9.477,5.472a2.328,2.328,0,0,0,2.328,0l9.477-5.472a2.328,2.328,0,0,0,1.164-2.017",
    transform: "translate(574.76 37.999)",
    fill: "#99b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M25.876,38.114V13.7a2.329,2.329,0,0,0-1.164-2.017l-7.58-4.376a2.33,2.33,0,0,0-2.328,0L7.224,11.685A2.329,2.329,0,0,0,6.06,13.7V38.114a2.328,2.328,0,0,0,1.164,2.017L14.8,44.507a2.328,2.328,0,0,0,2.328,0l7.58-4.376a2.328,2.328,0,0,0,1.164-2.017",
    transform: "translate(570.598 33.003)",
    fill: "#e0effd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M28.17,60.247l-2.684,1.41L26,58.669l-2.172-2.116,3-.435L28.17,53.4l1.342,2.72,3,.435-2.171,2.116.513,2.989Z",
    transform: "translate(558.396 1.603)",
    fill: "#99b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M28.17,27.286,25.486,28.7,26,25.708l-2.172-2.116,3-.435,1.342-2.72,1.342,2.72,3,.435-2.171,2.116.513,2.989Z",
    transform: "translate(558.396 23.563)",
    fill: "#99b1c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M28.17,93.207l-2.684,1.41L26,91.629l-2.172-2.116,3-.435,1.342-2.72,1.342,2.72,3,.435-2.171,2.116.513,2.989Z",
    transform: "translate(558.396 -21.358)",
    fill: "#99b1c7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLevel3);
export default __webpack_public_path__ + "static/media/activeLevel3.770a3d5e369f14ed44d42985357748ed.svg";
export { ForwardRef as ReactComponent };